function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import React from 'react';
import { useSelector } from 'react-redux';
import MembershipButton from '../../components/button/MembershipButton';
import SubscribeButton from '../../components/button/SubscribeButton';
import Container from '../../components/containers/Container';
import { ESSENTIALS_MEMBERSHIP_BENEFITS, FREE_BENEFITS } from '../../constants/membership';
import routes from '../../routes/constants';
import text from '../../text';
import { userHasActiveMembership } from '../../utilities/user';
var FreeUserMembership = function() {
    var currentUser = useSelector(function(state) {
        return state.profileReducer.userProfile;
    });
    return /*#__PURE__*/ React.createElement("div", {
        className: "FreeUserMembership"
    }, /*#__PURE__*/ React.createElement(Container, {
        className: "p-4 d-flex flex-column mr-4"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "d-flex flex-column"
    }, /*#__PURE__*/ React.createElement("h4", {
        className: "mb-3"
    }, "".concat(text('free'), "*")), /*#__PURE__*/ React.createElement("p", null, text('freeBenefitsMessage')), /*#__PURE__*/ React.createElement("ul", {
        className: "mb-4"
    }, FREE_BENEFITS.map(function(item, i) {
        return /*#__PURE__*/ React.createElement("li", {
            key: i,
            className: "mb-2"
        }, item);
    }))), /*#__PURE__*/ React.createElement("div", {
        className: "d-flex flex-column justify-content-between flex-fill"
    }, /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement("p", {
        className: "mb-0"
    }, text('findOutMoreOnPage', {
        page: ''
    })), /*#__PURE__*/ React.createElement("a", {
        rel: "noreferrer",
        target: "_blank",
        href: routes.larkiWebsiteUrl.memberships
    }, text('membershipPage'))), /*#__PURE__*/ React.createElement("a", {
        className: "mt-7",
        target: "_blank",
        rel: "noreferrer",
        href: routes.larkiWebsiteUrl.custTermsCond
    }, "".concat(text('termsAndCondApply'), "*")))), /*#__PURE__*/ React.createElement(Container, {
        className: "d-flex flex-column essentials-upgrade-specs",
        isSecondary: true
    }, /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("h4", {
        className: "mb-3"
    }, "".concat(text('upgradeEssentialsMembership'), "*")), /*#__PURE__*/ React.createElement("div", {
        className: "mb-3"
    }, /*#__PURE__*/ React.createElement("p", {
        className: "mb-0"
    }, text('upgradeEssentialsBenefits'))), /*#__PURE__*/ React.createElement("div", {
        className: "mb-3"
    }, /*#__PURE__*/ React.createElement("ul", null, _to_consumable_array(ESSENTIALS_MEMBERSHIP_BENEFITS).map(function(item, i) {
        return /*#__PURE__*/ React.createElement("li", {
            key: i,
            className: "mb-2"
        }, item);
    }))), /*#__PURE__*/ React.createElement("div", {
        className: "mb-4"
    }, /*#__PURE__*/ React.createElement("p", {
        className: "mb-0"
    }, text('findOutMoreOnPage', {
        page: ''
    })), /*#__PURE__*/ React.createElement("a", {
        rel: "noreferrer",
        target: "_blank",
        href: routes.larkiWebsiteUrl.memberships
    }, text('membershipPage')))), /*#__PURE__*/ React.createElement("div", {
        className: "d-flex flex-row",
        style: {
            gap: 16
        }
    }, !userHasActiveMembership(currentUser) && !currentUser.has_used_trial && /*#__PURE__*/ React.createElement(MembershipButton, null), /*#__PURE__*/ React.createElement(SubscribeButton, null))));
};
export default FreeUserMembership;
